import { useCallback, useEffect, useState } from 'react';
import { BREAKPOINTS } from "../../constants";
import { Breakpoint, BreakpointValue } from "../../types";
/**
 * The useMediaQuery hook that checks breakpoint and attaches change event.
 * @param {string|number} breakpoint - Breakpoint.
 * @returns {boolean} - Boolean value that depends on whether the target is reached.
 */
const useMediaQuery = (breakpoint) => {
    const [targetReached, setTargetReached] = useState(false);
    const width = typeof breakpoint === 'number' ? breakpoint : BREAKPOINTS[breakpoint];
    const updateTarget = useCallback((e) => {
        setTargetReached(e.matches);
    }, []);
    useEffect(() => {
        const media = breakpoint === BREAKPOINTS.xlarge
            ? window.matchMedia(`(min-width: ${width}px)`)
            : window.matchMedia(`(max-width: ${width}px)`);
        if (media.matches !== targetReached) {
            setTargetReached(media.matches);
        }
        media.addEventListener('change', updateTarget);
        return () => media.removeEventListener('change', updateTarget);
    }, []);
    return targetReached;
};
export default useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map